import {useState} from '../../app3';
import api from '../../api';

function formatTextNodes(h, textObj) {

  const rows = textObj.text.split("\n");

  return rows.map(row => {
    if(row === '') {
      return h('br')
    }

    return String(row);
  });
}

export default function Chat({airgram, store, props}) {
  const [state, patch] = useState({
    currentChatId: null,
    messages: [],
  });

  // api.chats.getChat({
  //   chatId: props.currentChatId,
  // })
  //   .then((chat) => {
  //     console.log(chat);
  //   });

  // airgram.api.getChatHistory({
  //   chatId: 777000,
  //   fromMessageId: 0,
  //   offset: 0,
  //   limit: 100,
  //   onlyLocal: false,
  // }).then(({response}) => {
  //   console.log(response);
  // });

  store.stores.chats.$on('update:activeChatId', async (chatId) => {
    console.log('SUCCESS!!!!!!!!!!!!!!!!!!!!!!', chatId);

    const chat = await api.chats.getChat({chatId});
    console.log(chat);
    const history = await api.chats.getChatHistory({
      chatId,
      fromMessageId: chat.lastMessage.id,
      offset: 0,
      limit: 100,
      onlyLocal: false,
    });

    console.log(history, state);
    patch({
      currentChatId: chatId,
      messages: [
        ...history.messages.reverse()
      ]
    })
  })

  async function downloadFile(file) {
    //
  }

  function sortedMessages(messages) {
    let blocks = [];
    let prevItem = null;
    let currentBlock = [];

    for(let message of messages) {
      if(!prevItem) {
        currentBlock.push(message);

        prevItem = message;
        continue;
      }

      if(prevItem.senderUserId === message.senderUserId) {
        currentBlock.push(message);
        prevItem = message;
        continue;
      }

      blocks.push(currentBlock);
      currentBlock = [];
      prevItem = null;
    }

    return blocks;
  }

  return h => {
    return h('div', 'chat-container', [
      h('div', 'chat-container__top'),
      h('div', 'chat-container__content', [
        h('div', 'chat-messages', [
          ...sortedMessages(state.messages).map(block => {
            return h('div', 'messages-party', [
              h('div', 'messages-party__list', [
                ...block.map(message => {
                  return h('div', 'messages-party__message message message--income', [
                    h('div', 'message__wrapper', [
                      h('p', 'message__text', [
                        ...formatTextNodes(h, message.content.text || {text: '', entities: []})
                      ])
                    ])
                  ])
                })
              ]),
              h('div', 'messages-party__author', [
                h('div', 'avatar', [
                  h('div', 'not-avatar', 'Tg')
                ])
              ])
            ])
          }),
        ])
      ])
    ])
  }
}
